var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#439288",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 14.6666H33.3334C34.3943 14.6666 35.4117 15.0881 36.1618 15.8382C36.912 16.5883 37.3334 17.6058 37.3334 18.6666V37.3333C37.3334 37.6869 37.1929 38.0261 36.9429 38.2761C36.6928 38.5262 36.3537 38.6666 36.0001 38.6666H32.0001",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 28V30.6666M18.6667 14.6666L28.7841 16.6906C29.6907 16.8718 30.5066 17.3616 31.093 18.0765C31.6793 18.7914 31.9998 19.6874 32.0001 20.612V39.7066C32 39.9038 31.9561 40.0985 31.8717 40.2767C31.7872 40.4549 31.6643 40.6122 31.5118 40.7372C31.3593 40.8621 31.1809 40.9517 30.9896 40.9995C30.7983 41.0472 30.5988 41.0519 30.4054 41.0133L20.8107 39.096C20.206 38.9751 19.6619 38.6483 19.2709 38.1714C18.88 37.6944 18.6665 37.0967 18.6667 36.48V14.6666Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.ecc161825cff1a632c9d1c6931a301bb.svg";
export { ForwardRef as ReactComponent };